module.exports = __webpack_public_path__ + "static/gallery1-25975bb844f5e0431b695846f1236103.png";